import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { getDateDifferenceInSeconds } from '@pv-frontend/pv-shared-services/utils/time';
import { interval } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@pv-frontend/pv-shared-components/button';
import { PvButtonModule } from '@pv-frontend/pv-shared-components/button';
import * as i3 from '@pv-frontend/pv-shared-components/svg-icon';
import { SvgIconModule } from '@pv-frontend/pv-shared-components/svg-icon';
import * as i4 from '@pv-frontend/pv-shared-directives/pipes/countdown';
import { PvCountdownPipeModule } from '@pv-frontend/pv-shared-directives/pipes/countdown';

class CountdownComponent {
    constructor() {
        this.countdownValue = 0;
        this.buttonStyle = {
            padding: 0,
        };
        this.timeInSeconds = null;
        this.date = null;
        this.textBefore = '';
        this.textAfter = '';
        this.showZeroMinutes = true;
        this.showZeroHours = false;
        /**
         * Indicates whether to show a suffix for the value.
         * If set to `true`, a suffix will be appended to the displayed value like 2d 2h 30m 20s.
         */
        this.showSuffix = false;
        /**
         * For some use cases, even after the button click you may want to restart the countdown
         * Ex - When sending OTP, we always restart counter as customer might not be getting OTP
         */
        this.restartCounter = false;
        this.style = {};
        this.timeoutEmitter = new EventEmitter();
        /**
         * To show resend icon before the textAfter & textBefore
         */
        this.resendOtpIconName = '';
        /**
         * To show resend icon before the textAfter & textBefore, when using name attribute & if the assets is not available. We will be using url attribute of svg.
         */
        this.resendOtpIconUrl = '';
    }
    ngOnInit() {
        this.startCountdown();
    }
    startCountdown() {
        this.countdownValue = this.timeInSeconds
            ? this.timeInSeconds
            : this.date
                ? getDateDifferenceInSeconds(this.date)
                : 0;
        this.countdownSubscription = interval(1000).subscribe(() => {
            if (this.countdownValue > 0) {
                this.countdownValue--;
            }
            else {
                this.stopCountdown();
            }
        });
    }
    stopCountdown() {
        this.countdownSubscription?.unsubscribe();
    }
    handleClick() {
        this.timeoutEmitter.emit();
        if (this.restartCounter) {
            this.startCountdown();
        }
    }
    ngOnDestroy() {
        this.stopCountdown();
    }
}
CountdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CountdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CountdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: CountdownComponent, selector: "pv-countdown", inputs: { timeInSeconds: "timeInSeconds", date: "date", textBefore: "textBefore", textAfter: "textAfter", showZeroMinutes: "showZeroMinutes", showZeroHours: "showZeroHours", showSuffix: "showSuffix", restartCounter: "restartCounter", style: "style", resendOtpIconName: "resendOtpIconName", resendOtpIconUrl: "resendOtpIconUrl" }, outputs: { timeoutEmitter: "timeoutEmitter" }, ngImport: i0, template: "<div\n  class=\"pv-countdown-container flex flex-row text-sm text-primary\"\n  [style]=\"this?.style?.container\">\n  <div\n    class=\"pv-countdown-timer flex flex-row gap-1 align-items-center\"\n    *ngIf=\"this.countdownValue > 0; else postTimer\"\n    [style]=\"this?.style?.countdownContainer\">\n    <ng-template\n      *ngIf=\"resendOtpIconName || resendOtpIconUrl\"\n      [ngTemplateOutlet]=\"resendOtpIcon\"></ng-template>\n    <span [style]=\"this?.style?.textBefore\" *ngIf=\"this.textBefore\">\n      {{ this.textBefore }}\n    </span>\n    <span [style]=\"this?.style?.countDownValue\">\n      {{\n        this.countdownValue\n          | countdownFormat\n            : this.showZeroHours\n            : this.showZeroMinutes\n            : !!this.showSuffix\n      }}\n    </span>\n  </div>\n  <ng-template #postTimer>\n    <ng-container *ngIf=\"this.textAfter\">\n      <pv-button\n        variant=\"text\"\n        size=\"small\"\n        [label]=\"this.textAfter\"\n        [style]=\"this.style?.textAfterButtonStyle ?? this.buttonStyle\"\n        (clickEvent)=\"this.handleClick()\">\n        <ng-template\n          *ngIf=\"resendOtpIconName || resendOtpIconUrl\"\n          [ngTemplateOutlet]=\"resendOtpIcon\"></ng-template>\n      </pv-button>\n    </ng-container>\n  </ng-template>\n\n  <ng-template #resendOtpIcon>\n    <pv-svg-icon\n      [style]=\"this.style?.resendOtpIconStyle\"\n      [name]=\"resendOtpIconName\"\n      [srcUrl]=\"resendOtpIconUrl\"></pv-svg-icon>\n  </ng-template>\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2.ButtonComponent, selector: "pv-button", inputs: ["style", "styleClass", "variant", "isRounded", "isDisabled", "isLoading", "type", "size", "label", "analyticsEnabledForButton", "labelForAnalytics"], outputs: ["clickEvent"] }, { kind: "component", type: i3.SvgIconComponent, selector: "pv-svg-icon", inputs: ["name", "srcUrl", "style", "styleClass"] }, { kind: "pipe", type: i4.PvCountdownFormatPipe, name: "countdownFormat" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CountdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pv-countdown', template: "<div\n  class=\"pv-countdown-container flex flex-row text-sm text-primary\"\n  [style]=\"this?.style?.container\">\n  <div\n    class=\"pv-countdown-timer flex flex-row gap-1 align-items-center\"\n    *ngIf=\"this.countdownValue > 0; else postTimer\"\n    [style]=\"this?.style?.countdownContainer\">\n    <ng-template\n      *ngIf=\"resendOtpIconName || resendOtpIconUrl\"\n      [ngTemplateOutlet]=\"resendOtpIcon\"></ng-template>\n    <span [style]=\"this?.style?.textBefore\" *ngIf=\"this.textBefore\">\n      {{ this.textBefore }}\n    </span>\n    <span [style]=\"this?.style?.countDownValue\">\n      {{\n        this.countdownValue\n          | countdownFormat\n            : this.showZeroHours\n            : this.showZeroMinutes\n            : !!this.showSuffix\n      }}\n    </span>\n  </div>\n  <ng-template #postTimer>\n    <ng-container *ngIf=\"this.textAfter\">\n      <pv-button\n        variant=\"text\"\n        size=\"small\"\n        [label]=\"this.textAfter\"\n        [style]=\"this.style?.textAfterButtonStyle ?? this.buttonStyle\"\n        (clickEvent)=\"this.handleClick()\">\n        <ng-template\n          *ngIf=\"resendOtpIconName || resendOtpIconUrl\"\n          [ngTemplateOutlet]=\"resendOtpIcon\"></ng-template>\n      </pv-button>\n    </ng-container>\n  </ng-template>\n\n  <ng-template #resendOtpIcon>\n    <pv-svg-icon\n      [style]=\"this.style?.resendOtpIconStyle\"\n      [name]=\"resendOtpIconName\"\n      [srcUrl]=\"resendOtpIconUrl\"></pv-svg-icon>\n  </ng-template>\n</div>\n" }]
        }], propDecorators: { timeInSeconds: [{
                type: Input
            }], date: [{
                type: Input
            }], textBefore: [{
                type: Input
            }], textAfter: [{
                type: Input
            }], showZeroMinutes: [{
                type: Input
            }], showZeroHours: [{
                type: Input
            }], showSuffix: [{
                type: Input
            }], restartCounter: [{
                type: Input
            }], style: [{
                type: Input
            }], timeoutEmitter: [{
                type: Output
            }], resendOtpIconName: [{
                type: Input
            }], resendOtpIconUrl: [{
                type: Input
            }] } });

class PvCountdownModule {
}
PvCountdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvCountdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PvCountdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PvCountdownModule, declarations: [CountdownComponent], imports: [CommonModule, PvButtonModule, PvCountdownPipeModule, SvgIconModule], exports: [CountdownComponent] });
PvCountdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvCountdownModule, imports: [CommonModule, PvButtonModule, PvCountdownPipeModule, SvgIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvCountdownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PvButtonModule, PvCountdownPipeModule, SvgIconModule],
                    declarations: [CountdownComponent],
                    exports: [CountdownComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CountdownComponent, PvCountdownModule };
